import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/lib/content";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import PaymentResult from "@/pages/PaymentResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminInvoice from "@/pages/AdminInvoice";
import LegalPage from "@/pages/LegalPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ContentProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/buchen" element={<BookingPage />} />
            <Route path="/zahlung/erfolg" element={<PaymentResult kind="success" />} />
            <Route path="/zahlung/abbruch" element={<PaymentResult kind="cancel" />} />
            <Route path="/impressum" element={<LegalPage kind="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
            <Route path="/agb" element={<LegalPage kind="agb" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/rechnung/:id" element={<AdminInvoice />} />
          </Routes>
        </ContentProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
